// extracted by mini-css-extract-plugin
export default {"cell":"CheckboxCell-module__cell__Ohh+4"};